import React from 'react';
import PropTypes from 'prop-types';

import Button from '../../elements/Button';
import ImageAchHero from './ImageAchHero';
import ImageInstantHero from './ImageInstantHero';
import ImageMailHero from './ImageMailHero';
import ImagePrintHero from './ImagePrintHero';
import ImageRtpHero from './ImageRtpHero';
import ImageVccHero from './ImageVccHero';

import './style.scss';
import ImageZelleHero from './ImageZelleHero';

function ProductHero(props) {
    const { title, description, buttons, image, productName } = props;
    let split_title = title.split('  ');

    return (
        <div className="product-hero-container">
            <div className="product-hero row g-0">
                <div className="text-panel col-lg-6">
                    <h1>
                        {split_title.map((line, i) => {
                            return (
                                <>
                                    {line}
                                    <br />
                                </>
                            );
                        })}
                    </h1>

                    <p className="hero-text">{description}</p>

                    <div>
                        {buttons.map((button, i) => {
                            return (
                                <Button
                                    src={button.link}
                                    value={button.text}
                                    option={button.option}
                                    disableArrowShift="true"
                                />
                            );
                        })}
                    </div>
                </div>
                <div className="image-panel col-lg-6">
                    {props.page === 'achPayment' && (
                        <ImageAchHero
                            id={productName}
                            src={image}
                            alt={productName}
                        />
                    )}
                    {props.page === 'instantPayment' && (
                        <ImageInstantHero
                            id={productName}
                            src={image}
                            alt={productName}
                        />
                    )}
                    {props.page === 'mailPayment' && (
                        <ImageMailHero
                            id={productName}
                            src={image}
                            alt={productName}
                        />
                    )}
                    {props.page === 'printPayment' && (
                        <ImagePrintHero
                            id={productName}
                            src={image}
                            alt={productName}
                        />
                    )}
                    {props.page === 'rtpPayment' && (
                        <ImageRtpHero
                            id={productName}
                            src={image}
                            alt={productName}
                        />
                    )}
                    {props.page === 'vccPayment' && (
                        <ImageVccHero
                            id={productName}
                            src={image}
                            alt={productName}
                        />
                    )}
                    {props.page === 'fednowPayment' && (
                        <ImageRtpHero
                            id={productName}
                            src={image}
                            alt={productName}
                        />
                    )}
                    {props.page === 'zellePayment' && (
                        <ImageZelleHero
                            id={productName}
                            src={image}
                            alt={productName}
                        />
                    )}
                </div>
            </div>
        </div>
    );
}

ProductHero.propTypes = {
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    buttons: PropTypes.array.isRequired,
};

export default ProductHero;
